// Cart Drawer
(function() {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const FREE_SHIPPING_THRESHOLD = parseInt(drawer.dataset.shippingThreshold || '12000', 10);

  const body = document.querySelector('[data-cart-drawer-body]');
  const itemsContainer = document.querySelector('[data-cart-items]');
  const emptyState = document.querySelector('[data-cart-empty]');
  const footer = document.querySelector('[data-cart-footer]');
  const subtotalEl = document.querySelector('[data-cart-subtotal]');
  const shippingText = document.querySelector('[data-shipping-text]');
  const shippingProgress = document.querySelector('[data-shipping-progress]');

  function open() {
    drawer.hidden = false;
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    });
  }

  function close() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    setTimeout(() => { drawer.hidden = true; }, 300);
  }

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function updateShipping(totalPrice) {
    if (!shippingText || !shippingProgress) return;
    const remaining = FREE_SHIPPING_THRESHOLD - totalPrice;
    if (remaining <= 0) {
      shippingText.textContent = 'You qualify for free shipping!';
      shippingProgress.style.width = '100%';
    } else {
      shippingText.textContent = `${formatMoney(remaining)} away from free shipping`;
      shippingProgress.style.width = `${Math.min((totalPrice / FREE_SHIPPING_THRESHOLD) * 100, 100)}%`;
    }
  }

  function renderCart(cart) {
    // Update count badges
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
    });

    if (cart.item_count === 0) {
      emptyState.hidden = false;
      itemsContainer.hidden = true;
      footer.hidden = true;
      return;
    }

    emptyState.hidden = true;
    itemsContainer.hidden = false;
    footer.hidden = false;

    itemsContainer.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-cart-item data-line-key="${item.key}">
        <img src="${item.image ? item.image.replace(/(\.[^.]+)$/, '_72x$1') : ''}" alt="${item.title}" class="cart-item__image" loading="lazy">
        <div class="cart-item__info">
          <p class="cart-item__title"><a href="${item.url}">${item.product_title || item.title}</a></p>
          ${item.variant_title ? `<p class="cart-item__variant">${item.variant_title}</p>` : ''}
          <div class="cart-item__quantity">
            <button class="cart-item__qty-btn" data-cart-qty-minus aria-label="Decrease">-</button>
            <span class="cart-item__qty-value">${item.quantity}</span>
            <button class="cart-item__qty-btn" data-cart-qty-plus aria-label="Increase">+</button>
          </div>
        </div>
        <div class="cart-item__right">
          <span class="cart-item__price">${formatMoney(item.final_line_price)}</span>
          <button class="cart-item__remove" data-cart-remove aria-label="Remove">Remove</button>
        </div>
      </div>
    `).join('');

    subtotalEl.textContent = formatMoney(cart.total_price);
    updateShipping(cart.total_price);
  }

  async function fetchCart() {
    const res = await fetch('/cart.json');
    return res.json();
  }

  async function updateItem(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!res.ok) {
        const cart = await fetchCart();
        renderCart(cart);
        return;
      }
      const cart = await res.json();
      renderCart(cart);
    } catch {
      const cart = await fetchCart();
      renderCart(cart);
    }
  }

  async function addToCart(formData) {
    await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });
    const cart = await fetchCart();
    renderCart(cart);
    open();
  }

  // Open/close handlers
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-toggle]')) {
      e.preventDefault();
      fetchCart().then(renderCart).then(() => open());
    }
    if (e.target.closest('[data-cart-drawer-close]')) {
      close();
    }
  });

  // Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  // Intercept add-to-cart forms
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-add-to-cart-form], [data-product-form]');
    if (!form) return;
    e.preventDefault();
    addToCart(new FormData(form));
  });

  // Quantity & remove in cart
  document.addEventListener('click', (e) => {
    const item = e.target.closest('[data-cart-item]');
    if (!item) return;

    const key = item.dataset.lineKey;
    const qtyEl = item.querySelector('.cart-item__qty-value');
    const qty = parseInt(qtyEl.textContent, 10);

    if (e.target.closest('[data-cart-qty-minus]')) {
      updateItem(key, Math.max(0, qty - 1));
    }
    if (e.target.closest('[data-cart-qty-plus]')) {
      updateItem(key, qty + 1);
    }
    if (e.target.closest('[data-cart-remove]')) {
      updateItem(key, 0);
    }
  });

  // Initial render
  fetchCart().then(renderCart);
})();
